import { STab, STabList, STabPanel, STabs } from "../../styles/Tabs";

import { UnitMatters } from "./UnitMatters";
import { UnitOverview } from "./UnitOverview";
import PropTypes from "prop-types";
import { StyledUnitBody } from "../../styles/StyledUnit";
import { UnitMembers } from "./UnitMembers";
import { UnitMeetings } from "./UnitMeetings";

export default function UnitBody({ id, newUnit, edit, refetch, upperUnitId }) {
	return (
		<StyledUnitBody sm={12}>
			<STabs selectedTabClassName="is-selected" selectedTabPanelClassName="is-selected">
				<STabList className={newUnit ? "disabled" : ""}>
					<STab disabled={newUnit}>Description</STab>
					<STab disabled={newUnit}>Matters</STab>
					<STab disabled={newUnit}>Members</STab>
					<STab disabled={newUnit}>Meetings</STab>
				</STabList>
				<STabPanel className={newUnit ? "disabled" : ""}>
					<UnitOverview edit={edit || newUnit} id={id} refetch={refetch} upperUnitId={upperUnitId} />
				</STabPanel>
				<STabPanel className={newUnit ? "disabled" : ""}>
					<UnitMatters id={id} />
				</STabPanel>
				<STabPanel className={newUnit ? "disabled" : ""}>
					<UnitMembers id={id} />
				</STabPanel>
				<STabPanel className={newUnit ? "disabled" : ""}>
					<UnitMeetings id={id} />
				</STabPanel>
			</STabs>
		</StyledUnitBody>
	);
}

UnitBody.propTypes = {
	newUnit: PropTypes.bool,
	id: PropTypes.string,
	edit: PropTypes.bool,
	refetch: PropTypes.func,
	upperUnitId: PropTypes.any,
};
